// store/conversationSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ConversationInfo {
  id: string;
  title: string;
}

interface ConversationState {
  currentId: string | null;
  info: ConversationInfo | null;
}

const initialState: ConversationState = {
  currentId: null,
  info: null,
};

const conversationSlice = createSlice({
  name: "conversation",
  initialState,
  reducers: {
    setCurrentConversationIdGlobal(state, action: PayloadAction<string>) {
      state.currentId = action.payload;
    },
    setConversationInfo(state, action: PayloadAction<ConversationInfo>) {
      state.info = action.payload;
    },
    clearConversation(state) {
      state.currentId = null;
      state.info = null;
    },
  },
});

export const {
  setCurrentConversationIdGlobal,
  setConversationInfo,
  clearConversation,
} = conversationSlice.actions;

export default conversationSlice.reducer;